import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as me from '../../me'

import { getActionsConfig } from './actions'
import * as extraReducers from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/** TODO: Explain what is this */
@ngCore.Injectable()
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor() {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'mosaic.Aliases',
      selectors: () => new Selectors(this),
    })

    const meFeature = ngCore.inject(me.Feature)
    this.registerEffects(extraReducers.resetOnZoneChange(meFeature))
  }
}
